/**
 * THIS MODULE IS GENERATED: DO NOT EDIT MANUALLY.
 *
 * Generated from backend/dsit/permer/__init__.py REQUIREMENTS_DESCRIPTION
 * using backend/scripts/permer/generate-frontend-requirements script.
 */
import { has_requirement } from "@ouihelp/permer_web";

export const PERMER_NO_ATTRIBUTES = "no-attribute";

const hasRequirement = (
  requirement: string,
  serializedSecurityPolicy: any,
  serializedUserAttributes: string[]
): boolean => {
  return has_requirement(
    requirement,
    JSON.stringify(serializedSecurityPolicy),
    JSON.stringify(serializedUserAttributes)
  );
};

export type PermerRequirements = {
  hasDsitAdminGeneral: () => boolean;
  hasDsitAdminDsi: () => boolean;
  hasDsitUserEdit: () => boolean;
  hasDsitUserEditAdvanced: () => boolean;
  hasDsitUserAssignRareJob: () => boolean;
  hasDsitUserAssignFounder: () => boolean;
  hasDsitUserPostingDelete: () => boolean;
  hasDsitGeographyPostalCodesEdit: () => boolean;
  hasDsitGeographyAgenciesEdit: () => boolean;
  hasDsitGeographyZonesEdit: () => boolean;
  hasDsitFinancialHelpsEdit: () => boolean;
};

export const makePermerRequirements = (
  userAttributes: string[],
  securityPolicy: { [role: string]: string[] }
): PermerRequirements => {
  return {
    hasDsitAdminGeneral: () => hasRequirement(`dsit:admin:general`, securityPolicy, userAttributes),
    hasDsitAdminDsi: () => hasRequirement(`dsit:admin:dsi`, securityPolicy, userAttributes),
    hasDsitUserEdit: () => hasRequirement(`dsit:user:edit`, securityPolicy, userAttributes),
    hasDsitUserEditAdvanced: () =>
      hasRequirement(`dsit:user:edit-advanced`, securityPolicy, userAttributes),
    hasDsitUserAssignRareJob: () =>
      hasRequirement(`dsit:user:assign-rare-job`, securityPolicy, userAttributes),
    hasDsitUserAssignFounder: () =>
      hasRequirement(`dsit:user:assign-founder`, securityPolicy, userAttributes),
    hasDsitUserPostingDelete: () =>
      hasRequirement(`dsit:user:posting:delete`, securityPolicy, userAttributes),
    hasDsitGeographyPostalCodesEdit: () =>
      hasRequirement(`dsit:geography:postal-codes:edit`, securityPolicy, userAttributes),
    hasDsitGeographyAgenciesEdit: () =>
      hasRequirement(`dsit:geography:agencies:edit`, securityPolicy, userAttributes),
    hasDsitGeographyZonesEdit: () =>
      hasRequirement(`dsit:geography:zones:edit`, securityPolicy, userAttributes),
    hasDsitFinancialHelpsEdit: () =>
      hasRequirement(`dsit:financial-helps:edit`, securityPolicy, userAttributes),
  };
};
